<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">材料调拨</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">

          <el-form-item label="调出仓库">
            <el-col :span="10">
              <el-select size="small" class="organization-select" v-model="form.outHouseId" placeholder="请选择调出仓库">
                <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="调入仓库">
            <el-col :span="10">
              <el-select size="small" class="organization-select" v-model="form.inHouseId" placeholder="请选择调入仓库">
                <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="调拨时间">
            <el-date-picker v-model="form.time" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
              placeholder="选择材料调拨时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="材料明细">
            <section class="material-list">
              <div class="list-title">
                <div class="r">
                  <el-button @click="AddMaterial()" type="primary" size="mini">添加材料</el-button>
                </div>
              </div>
              <div class="material-table">
                <el-table :data="form.materials" border>
                  <el-table-column prop="material.material.number" label="材料编号">
                  </el-table-column>
                  <el-table-column prop="material.material.name" width="260" label="明细名称">
                  </el-table-column>
                  <!-- <el-table-column prop="dl" label="材料类别">
                  </el-table-column> -->
                  <el-table-column prop="material.material.unit.name" align="center" label="计量单位">
                  </el-table-column>
                  <el-table-column prop="" align="center" label="数量"><template slot-scope="scope">
                      {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="material.amount" align="center" label="总库存">
                  </el-table-column>
                  <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="点击变更信息" placement="bottom">
                        <i @click="MaterialChange(scope.row, scope.$index)"
                          class="iconfont icon-xiugai meeting-btn-icon  mbi-edit"></i>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="点击删除" placement="bottom">
                        <i @click="MaterialDelete(scope.$index)"
                          class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </section>
          </el-form-item>

          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitMaterial()" class="form-btn" type="success">确认提交材料调拨单
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>

    <!-- 添加材料 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="mform" label-width="120px" class="form">
            <el-form-item label="材料编号" v-if="mform.material">
              <el-input :disabled="true" size="small" v-model="mform.material.material.number"></el-input>
            </el-form-item>
            <el-form-item label="*明细名称">
              <el-select size="small" style="width:100%" filterable v-model="mform.materialId" @change="handleSelect"
                placeholder="支持搜索">
                <el-option v-for="item in materialList" :key="item.id"
                  :label="item.name+' ('+item.dl.name+') ('+item.spec+')'" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="*调出数量">
              <el-input size="small" type="number" v-model="mform.amount"></el-input>
            </el-form-item>
            <el-form-item label="实时库存" v-if="mform.material">
              <el-input size="small" :disabled="true" type="number" v-model="mform.material.amount"></el-input>
            </el-form-item>
            <el-form-item label="计量单位" v-if="mform.material">
              <el-select :disabled="true" size="small" filterable v-model="mform.material.material.unit.id"
                placeholder="请选择计量单位">
                <el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="价格(元)" v-if="mform.material">
              <el-input :disabled="true" size="small" type="number" v-model="mform.material.price"></el-input>
            </el-form-item> -->

            <el-form-item label="">
              <el-button @click="AddBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  export default {
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,

        houseList: '',
        supplierList: '',
        unitList: '',
        materialList: '',

        form: {
          outHouseId: '',
          inHouseId: '',
          total: 0,
          time: '',
          materials: [],
          json: true,
        },
        addType: 0,
        editIndex: '',
        mform: {
          material: [],
          materialId: '',
          amount: '',
        },

        depId: '',
        addStatus: false,
      }
    },
    created() {
      if (this.$route.params.houseId) {
        this.form.houseId = this.$route.params.houseId / 1
      }
      this.form.time = this.getNowTime()

      this.getHouseList()
      this.getSupplierList()
      this.getUnitList()
      // this.getMaterialList()
    },
    mounted() {
      this.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    methods: {
      // 选择材料后ajax查询材料详细
      handleSelect(materialId) {
        ajax.post('/storage/material/queryBy/id', {
          id: materialId,
          houseId: this.form.outHouseId
        }, (res) => {
          this.mform.material = res.vo
        })
      },
      // 获取当前时间
      getNowTime() {
        let _s = ""
        let _time = new Date()
        _s += _time.getFullYear() + "-"
        _s += (_time.getMonth() + 1) + "-"
        _s += _time.getDate() + " "
        _s += _time.getHours() + ":"
        _s += _time.getMinutes() + ":"
        _s += "00"
        return _s
      },
      // 提交材料调拨单
      SubmitMaterial() {
        if (!this.form.inHouseId) {
          this.$message.error("请先选择材料调入仓库")
          return
        }
        if (this.form.outHouseId == this.form.inHouseId) {
          this.$message.error("调入仓库与调出仓库不能是同一个仓库")
          return
        }
        ajax.post('/storage/material/allot', this.form, (res) => {
          this.loading = false
          this.$message.success("材料调拨成功")

          this.$router.push('/Storage/MaterialAllotList')
          // this.$router.push('/Storage/MaterialAllotList/' + this.form.houseId)
          // 初始化
          // this.form = {
          //   houseId: '',
          //   inVoice: '',
          //   supplierId: '',
          //   total: 0,
          //   time: '',
          //   materials: []
          // }
        })
      },
      // 编辑材料
      MaterialChange(row, index) {
        this.addType = 1
        this.editIndex = index
        this.mform = row
        this.addStatus = true
      },
      // 从列表里删除当前材料
      MaterialDelete(index) {
        // console.log(index)
        this.form.materials.splice(index, 1)
      },
      // 显示添加材料弹窗
      AddMaterial() {
        if (!this.form.outHouseId) {
          this.$message.error("请先选择材料调出仓库")
          return
        }
        this.mform = {
          material: '',
          materialId: '',
          amount: '',
        }
        this.addType = 0
        this.addStatus = true
      },
      // 添加材料到列表
      AddBtnClick() {
        if (!this.mform.materialId || !this.mform.amount) {
          this.$message.error("请认真填写材料信息，带*为必填项")
          return
        }
        if (this.mform.amount > parseFloat(this.mform.material.amount)) {
          this.$message.error("\"" + this.mform.material.material.name + "\"库存数量不足，请联系仓库管理员")
          return
        }

        // this.mform.totalPrice = this.mform.price * this.mform.amount
        // this.mform.unitName = this.getUnitName(this.mform.unitId)
        if (this.addType == 0) {
          this.form.materials.push(this.mform)
        } else {
          this.form.materials.splice(this.editIndex, 1, this.mform)
        }

        let _total = 0
        for (var i = 0; i < this.form.materials.length; i++) {
          _total += parseFloat(this.form.materials[i].totalPrice)
        }
        this.form.total = _total.toFixed(2)

        // 初始化
        this.mform = {
          material: '',
          materialId: '',
          amount: '',
        }
        this.addStatus = false
      },
      // 获得计量单位名称
      getUnitName(unitId) {
        for (var i = 0; i < this.unitList.length; i++) {
          let _item = this.unitList[i]
          if (unitId == _item.id) {
            return _item.name
          }
        }
      },
      // 获取材料基础资料列表
      getMaterialList() {
        // console.log(this.form.outHouseId)
        if (!this.form.outHouseId) {
          this.$message.error("请先选择调出仓库")
          return
        }
        ajax.get('/storage/material/orderby/stock/list', {
          houseId: this.form.outHouseId
        }, (res) => {
          this.loading = false
          this.materialList = res.vo.array
        })
      },
      // 获取仓库列表
      // 材料调拨仓库暂不支持跨公司
      getHouseList() {
        ajax.get('/storage/house/list', {
          'depId': this.depId
        }, (res) => {
          this.loading = false
          this.houseList = res.vo.array
        })
      },
      // 获取供应商列表
      getSupplierList() {
        ajax.get('/supplier/list', {
          'type': 1
        }, (res) => {
          this.loading = false
          this.supplierList = res.vo.array
        })
      },
      // 获取计量单位列表
      getUnitList() {
        ajax.get('/storage/unit/list', '', (res) => {
          this.loading = false
          this.unitList = res.vo.array
        })
      },
    },
    watch: {
      'form.outHouseId'() {
        this.getMaterialList()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/materialAllot.vue